import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../../environments/environment';

const USE_LOCAL_API_KEY = 'useLocalApi';

/**
 * When localStorage has useLocalApi === 'true', rewrites request URL from live API base to localApiUrl.
 * Toggle with Ctrl+Alt+3 (handled in App component).
 */
export const apiBaseInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof localStorage === 'undefined' || localStorage.getItem(USE_LOCAL_API_KEY) !== 'true') {
    return next(req);
  }

  const liveBase = (environment.apiUrl ?? '').replace(/\/v\d+$/i, '').replace(/\/$/, '');
  if (!liveBase || !req.url.startsWith(liveBase)) {
    return next(req);
  }

  const localBase = (environment.localApiUrl ?? '').replace(/\/$/, '');
  if (!localBase) return next(req);

  const liveOrigin = (() => {
    try {
      return new URL(liveBase).origin;
    } catch {
      return liveBase;
    }
  })();
  const newUrl = req.url.replace(liveOrigin, localBase);

  return next(req.clone({ url: newUrl }));
};
